import { connect } from "react-redux";
import Component from "../components/AppMenu";
import { setUIVisibilityState } from "../actions";
import { FakeChapters } from "../constants/chapters";
var mapStateToProps = function(state, ownProps) {
    return {
        favOnly: state.uiVisibilityState.favOnly,
        visible: state.uiVisibilityState.menu,
        isLodaing: state.loading.indexOf("fetch_locale") > -1 || state.loading.indexOf("fetch_cbook") > -1,
        name: !!state.cbook && !!state.cbook.name ? state.cbook.name : "",
        hasResult: !!state.search.results,
        nodes: state.uiVisibilityState.favOnly ? [
            {
                target_type: "Filter",
                alt: FakeChapters.FAVORITES,
                name: FakeChapters.FAVORITES,
                c: state.favorites
            }
        ] : state.cbook && state.cbook.c || []
    };
};
var mapDispatchToProps = function(dispatch, ownProps) {
    return {
        toggleFavOnly: function(favOnly) {
            dispatch(setUIVisibilityState({
                state: {
                    favOnly: favOnly
                }
            }));
        },
        toggleMenu: function(menu) {
            dispatch(setUIVisibilityState({
                state: {
                    menu: menu
                }
            }));
        },
        togglePrint: function() {
            dispatch(setUIVisibilityState({
                state: {
                    menu: false,
                    print: true
                }
            }));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Component);
